import { render, staticRenderFns } from "./ZipcodeDirectPopup.vue?vue&type=template&id=4b747bb4&scoped=true&"
import script from "./ZipcodeDirectPopup.vue?vue&type=script&lang=js&"
export * from "./ZipcodeDirectPopup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b747bb4",
  null
  
)

export default component.exports